module.exports = __webpack_public_path__ + "static/media/IntermediateAndroid.a5666c37.png";